import { useTransaction } from "hooks/useTransactions";
import * as i18n from "util/i18n";
import Button from "pages/_components/Button";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import React, { useState } from "react";
import { bool } from "prop-types";
import { Col, Row } from "react-bootstrap";
import { actions as massiveEcheck } from "reducers/echecks";
import MassiveEcheckSummaryBody from "./massiveEcheckSummaryBody";

const MassiveEcheckTransactionPage = ({ isDesktop }) => {
    const formatTransaction = (data, idTransaction) => ({ ...data, idTransaction });

    const {
        isLoading,
        transaction,
        dispatch,
        handleSignTransaction,
        showSignButton,
        push,
        id,
        status,
    } = useTransaction(
        `/massiveEchecks/confirm`,
        massiveEcheck.summaryMassiveEcheck,
        massiveEcheck.cleanEcheckTicket,
        formatTransaction,
    );

    const { isFlowComplete, isProcessing, isFinished, isBackoffice } = status;
    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "massive.echeck.title",
        id,
        "massiveEcheckSummary",
    );
    const [showMoreData, setShowMoreData] = useState(!isDesktop);

    const backLinkTo = isFlowComplete ? "/massiveEchecks" : "";

    const handleDownload = async () => {
        await setShowMoreData(true);
        return handlePrint();
    };

    return (
        <>
            <Notification scopeToShow="massiveEcheckSummary" />
            {!isBackoffice && <ResponsiveHeader ticket metaTitle="massive.echeck.title" backLinkTo={backLinkTo} />}
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader
                                title="massive.echeck.title"
                                subTitle={isProcessing ? "forms.transaction.ticket.status.PROCESSING" : ""}
                            />
                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <MassiveEcheckSummaryBody
                                        // ticket
                                        fromTransactionPage
                                        isDesktop={isDesktop}
                                        setShowMoreData={setShowMoreData}
                                        showMoreData={showMoreData}
                                    />
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            <Col xs={12} md={4} mdOffset={isFinished || showSignButton ? 2 : 4}>
                                <Button
                                    onClick={() => dispatch(push("/desktop"))}
                                    label="forms.transaction.ticket.actions.backToHome"
                                    className="btn btn-outline"
                                />
                            </Col>
                            <Col xs={12} md={4}>
                                {isFinished ? (
                                    <Button
                                        className="btn btn-primary"
                                        image="images/figma/icon/download.svg"
                                        label="global.download"
                                        onClick={handleDownload}
                                    />
                                ) : (
                                    <>
                                        {showSignButton && (
                                            <Button
                                                onClick={handleSignTransaction}
                                                label="forms.signTransaction.link"
                                                className="btn btn-primary"
                                            />
                                        )}
                                    </>
                                )}
                            </Col>
                            {isFinished && !isDesktop && (
                                <Col xs={12} md={4}>
                                    <Button
                                        className="btn btn-outline"
                                        image="images/figma/icon/share.svg"
                                        label="global.share"
                                        onClick={() => {
                                            handleShareMobile();
                                        }}
                                    />
                                </Col>
                            )}
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

MassiveEcheckTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default MassiveEcheckTransactionPage;
